import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import InfoOutlineRoundedIcon from '@mui/icons-material/InfoOutlineRounded';
import clsx from 'clsx';

import SlideButton from '../../../../../../id8/components/frames/slide-button/SlideButton';
import { REACTIONS } from '../../../../../../constants';
import DemoImage from '../demo-image/DemoImage';

import scss from './DemoSlide.module.scss';

function DemoSlide({ slide, onPreview, onLike, disabled, onShowSourceImage }) {
  const { t } = useTranslation('id8');

  const handleOpenPreview = () => {
    if (onPreview && !disabled) {
      onPreview();
    }
  };

  const handleLike = () => {
    if (onLike && !disabled) {
      onLike(slide);
    }
  };

  const handleShowSource = () => {
    if (!disabled) {
      onShowSourceImage(slide);
    }
  };

  return (
    <div className={scss.slide}>
      <DemoImage
        sessionId={slide.sessionId}
        className={scss.slideImage}
        onClick={handleOpenPreview}
        disabled={disabled}
        style={{ cursor: 'pointer' }}
      />

      <div className={scss.buttonsGroup}>
        {onShowSourceImage && (
          <SlideButton
            icon={InfoOutlineRoundedIcon}
            onClick={handleShowSource}
            ariaLabel='Show source image'
            tooltip={t('sourceImage')}
            disabled={disabled}
          />
        )}

        {onLike && (
          <SlideButton
            icon={slide.reaction === REACTIONS.LIKE ? FavoriteOutlinedIcon : FavoriteBorderOutlinedIcon}
            onClick={handleLike}
            ariaLabel='Like this picture'
            className={clsx(slide.reaction === REACTIONS.LIKE && scss.favoriteSlide)}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
}

export default memo(DemoSlide);
